import * as React from "react";
import { FocusTrap as FocusTrap$1 } from "focus-trap-react";
import { TrapChild } from "../components/FocusTrap/components/TrapChild.js";
const FocusTrap = ({ children, ...rest }) => /* @__PURE__ */ React.createElement(FocusTrap$1, { ...rest }, /* @__PURE__ */ React.createElement(TrapChild, null, children));
export {
  FocusTrap,
  FocusTrap as default
};
//# sourceMappingURL=FocusTrap.js.map
